import { createTheme } from '@mui/material/styles';
import palette from './palette';
import dimensions from './dimensions';
import components from './components';

const theme = createTheme({
  palette,
  dimensions,
  components,
  breakpoints: {
    values: {
      xs: 0,
      sm: 800, // <- cambiamos 'sm' de 600 a 800
      md: 960,
      lg: 1280,
      xl: 1920,
    },
  },
});

export default theme;
